var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 .583a7.417 7.417 0 1 1-.002 14.834A7.417 7.417 0 0 1 8 .583m2.828 5.5c.371.547.588 1.206.588 1.917 0 .548-.13 1.066-.36 1.525a.8.8 0 0 1-.06.16l-2.23 4.18a5.915 5.915 0 0 0 4.83-7.782zm-8.176-.617a5.918 5.918 0 0 0 4.425 8.378l1.307-2.45a3.414 3.414 0 0 1-3.332-1.668L5.036 9.7zM8 6.083a1.917 1.917 0 1 0 0 3.832 1.917 1.917 0 0 0 0-3.832m0-4a5.9 5.9 0 0 0-4.416 1.98L4.94 6.476A3.42 3.42 0 0 1 8 4.583h4.828A5.91 5.91 0 0 0 8 2.083",
    clipRule: "evenodd"
  })));
};
export default Svg16;